import React from 'react';
import Create from '../../../containers/rest/Create';
import Form from '../components/Form';

const PlatformsCreate = props => (
  <Create {...props} resource="platforms">
    <Form />
  </Create>
);

PlatformsCreate.propTypes = {};

export default PlatformsCreate;
